import bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

function getBugsnagClient() {
    return bugsnag.start({
        apiKey: 'a1993e6fa8bfb66fef4e5b0dd92f1bb7',
        appVersion: '3.0.0',
        autoCaptureSessions: false,
        collectUserIp: false,
        logger: null,
        plugins: [new BugsnagPluginVue()],
    });
}

export default getBugsnagClient
